// extracted by mini-css-extract-plugin
export default {"cell":"Urjfj","icon-close":"pdCzC","common-block":"GXK55","common-block__title":"p0IQb","common-block__list":"ybZwZ","common-block__list-history":"oMkJK"};